export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33643.c61a7d91.jpg";